export const WASTE_REASONS = [
    'expired',
    'spoiled',
    'quality_issue',
    'non_saleable',
    'prep_waste',
    'burnt',
    'spillage',
    'damaged',
    'staff_meal',
    'other',
];
export const WASTE_REASON_LABELS = {
    expired: 'Expired',
    spoiled: 'Spoiled',
    quality_issue: 'Quality issue',
    non_saleable: 'Non-saleable',
    prep_waste: 'Preparation waste',
    burnt: 'Burnt',
    spillage: 'Spillage',
    damaged: 'Damaged',
    staff_meal: 'Staff meal',
    other: 'Other',
};
/** Map legacy note reasons onto the current list. */
export function normalizeWasteReason(raw) {
    const key = (raw ?? '').trim().toLowerCase().replace(/\s+/g, '_');
    if (key === 'spilled' || key === 'spill')
        return 'spillage';
    if (WASTE_REASONS.includes(key))
        return key;
    return 'other';
}
export function wasteReasonLabel(raw) {
    return WASTE_REASON_LABELS[normalizeWasteReason(raw)];
}
/** First name in a staff-meal waste note (`staff_meal — Anna` or `staff_meal — Anna — extra`). */
export function staffMealRecipientFromNote(note) {
    if (!note)
        return null;
    const sep = note.indexOf(' — ');
    const reason = sep === -1 ? note : note.slice(0, sep);
    if (normalizeWasteReason(reason) !== 'staff_meal')
        return null;
    const detail = sep === -1 ? '' : note.slice(sep + 3);
    const name = detail.split(' — ')[0]?.trim();
    return name || null;
}
//# sourceMappingURL=waste.js.map